import React, { useState, useEffect } from 'react';
// Images
import AboutImage from '../../assets/images/small/mistress-sammi-smith-trans-dominatrix-outside-sitting-with-whip-small.jpg';
import ServiceImage from '../../assets/images/small/mistress-sammi-smith-trans-dominatrix-in-dungeon-with-racked-sub-small.jpg';

// Constants
import {
  ABOUT_PAGE_URL,
  SERVICES_PAGE_URL,
} from '../../utils/Routes';
import {
  LocationCity,
} from '../../utils/Constants';
import { Link } from 'react-router-dom';

function PlaySectionOne() {
  const [clipsImageSrc, setClipsImageSrc] = useState(AboutImage);

  useEffect(() => {
    const updateImage = () => {
      setClipsImageSrc(window.innerWidth < 768 ? AboutImage : ServiceImage);
    };

    updateImage(); // Set initial image
    window.addEventListener('resize', updateImage);

    return () => window.removeEventListener('resize', updateImage);
  }, []);

  const items = [
    {
      id: 1,
      title: 'Welcome to My World',
      subtitle: (
        <>
          Enter my domain, where power, seduction, and absolute control collide.
          I am <strong>Mistress Sammi Smith</strong>, a gorgeous transsexual
          dominatrix in {LocationCity}. Your desires are at my mercy, and your
          submission is my pleasure. Explore, obey, and experience true
          dominance.
        </>
      ),
    },
    {
      id: 2,
      title: 'About Mistress Sammi Smith',
      subtitle: 'More about my dominant role in life.',
      image: AboutImage,
      link: ABOUT_PAGE_URL,
    },
    {
      id: 3,
      title: 'Services',
      subtitle: 'Mistress Sammi provides services such as...',
      image: ServiceImage,
      link: SERVICES_PAGE_URL,
    },
  ];

  return (
    <section className='container mx-auto px-6 mt-6 lg:mt-0 lg:px-4'>
      <section className='mb-6 lg:mb-8'>
        <div className='angled_bg lg:w-1/2 pl-4 lg:pl-8 py-1 '>
          <h4 className='text-3xl lg:text-4xl xl:text-5xl font-titleFont text-center md:text-left md:px-4'>
            Explore My Website
          </h4>
        </div>
      </section>

      <section className='grid lg:grid-cols-3 gap-8 lg:gap-8'>
        {/* Render the first item as a text box */}
        <article className='grid bg-colour4 shadow-colour4 py-6 lg:py-4 xl:py-6 items-center shadow-cardShadowBold text-center'>
          <div className='grid gap-6 h-fit items-center'>
            <div className='h-fit px-4 lg:px-8'>
              <h5 className='font-titleFont font-semibold text-3xl lg:text-3xl xl:text-4xl bg-colour5 rounded w-full mx-auto shadow-cardShadowBold shadow-colour2/80'>
                {items[0].title}
              </h5>
            </div>
            <div className='text-center my-auto px-2 lg:px-2 lg:text-sm xl:text-base'>
              <p className='mt-2'>{items[0].subtitle}</p>
            </div>
          </div>
        </article>

        {/* Render the remaining items as links with images */}
        {items.slice(1).map((item) => (
          <Link
            to={item.link}
            key={item.id}
            className='border-b-2 grid grid-rows-rev pb-4 border-solid border-colour4'
          >
            <img
              src={item.image}
              alt={item.title}
              className='w-full h-full object-cover shadow-cardShadowBold shadow-colour4 max-h-[70vh] rounded'
              loading='lazy'
            />
            <div className='h-fit'>
              <h5 className='text-colour1 text-2xl lg:text-3xl font-titleFont mt-2 lg:mt-4 font-semibold'>
                {item.title}
              </h5>
              <p className='play-subtitle text-sm'>{item.subtitle}</p>
            </div>
          </Link>
        ))}
      </section>
    </section>
  );
}

export default PlaySectionOne;
